import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { FingerspellingDetailModal } from "../../components/fingerspelling/FingerspellingDetailModal";
import { FingerspellingTable } from "../../components/fingerspelling/FingerspellingTable";
import { SideSwitch } from "../../components/fingerspelling/SideSwitch";
import type {
  FingerspellingEntry,
  FingerspellingSide,
} from "../../lib/fingerspelling";

export const Route = createFileRoute("/_app/fingerspelling")({
  component: FingerspellingPage,
});

function FingerspellingPage() {
  const [side, setSide] = useState<FingerspellingSide>("aite");
  const [selected, setSelected] = useState<FingerspellingEntry | null>(null);

  return (
    <div className="space-y-3">
      <h1 className="text-2xl font-bold tracking-tight">指文字表</h1>
      <SideSwitch value={side} onChange={setSide} />
      <FingerspellingTable side={side} onSelect={setSelected} />
      {selected && (
        <FingerspellingDetailModal
          key={selected.id}
          entry={selected}
          side={side}
          onClose={() => setSelected(null)}
        />
      )}
    </div>
  );
}
